import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './NewTagDialog.module.css';
import { useCreateTagMutation, useGetTagTypesQuery } from '../../../generated/graphql';
import { FormField, FormAutoComplete, FormTextArea } from '../../form';

type NewTagDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewTagDialog = (props: NewTagDialogProps) => {
    const { style, visible, onClose } = props;
    const [name, setName] = useState('');
    const [tagType, setTagType] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');
    const types = useGetTagTypesQuery({ fetchPolicy: "no-cache" });
    const [createTag, createTagResult] = useCreateTagMutation();

    const handleSubmit = () => {
        if (!name || !description || !tagType) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        createTag({
            variables: {
                tag: { name, description, type: tagType }
            }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="New Tag"
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            isLoading={createTagResult.loading}
            className={styles.NewTagDialog}
            style={style}
            data-testid="NewTagDialog">
            <FormField label="Name" name="name" value={name} onChange={setName} />
            <FormAutoComplete
                label="Tag Type"
                name="type"
                value={tagType}
                onChange={setTagType}
                options={(types.data?.TagTypes || []).filter((t): t is string => !!t)}
            />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default NewTagDialog;